import Price from '~/utils/Price/Price';

export default class CountryOfOrigin {
	nationality: string | null;

	exFactoryPrice: Price | null;

	wholesalePrice: Price | null;

	publicPrice: Price | null;

	constructor(
		nationality: string | null,
		exFactoryPrice: Price | null,
		wholesalePrice: Price | null,
		publicPrice: Price | null
	) {
		this.nationality = nationality;
		this.exFactoryPrice = exFactoryPrice;
		this.wholesalePrice = wholesalePrice;
		this.publicPrice = publicPrice;
	}
}
